export interface PeriodOption {
  value: string;
  labelKey: string;
}

export const PERIOD_OPTIONS: PeriodOption[] = [
  { value: 'today', labelKey: 'LanguageService::Today' },
  { value: 'yesterday', labelKey: 'LanguageService::Yesterday' },
  { value: 'this-week', labelKey: 'LanguageService::ThisWeek' },
  { value: 'last-week', labelKey: 'LanguageService::LastWeek' },
  { value: 'this-month', labelKey: 'LanguageService::ThisMonth' },
  { value: 'last-month', labelKey: 'LanguageService::LastMonth' },
  { value: 'this-year', labelKey: 'LanguageService::ThisYear' },
  { value: 'last-year', labelKey: 'LanguageService::LastYear' },
];
